/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const SmallRectangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={2}
    height={10}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="SmallRectangle">
    <rect width="100%" height="100%" rx={1} fill="#F6A609" />
  </svg>
);

export default SmallRectangle;
